import { observer } from "mobx-react";
import { Checkbox } from "monday-ui-react-core";
import { useCallback } from "react";
import useOnValueChange from "../../../hooks/useOnValueChange";
import { ContextKeys } from "../../../types/context-key";
import { useStore } from "../../../store";
import Classes from "./ManagementFeesCheckbox.module.scss";

const ManagementFeesCheckbox = () => {
  const { context } = useStore();
  const onValueChange = useOnValueChange(ContextKeys.MANAGEMENT_FEES_ENABLED);

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onValueChange(event.target.checked);
    },
    [onValueChange]
  );

  return (
    <div className={Classes.checkboxWrapper}>
      <Checkbox
        checked={context.managementFeesEnabled}
        onChange={handleChange}
        className={Classes.checkbox}
        label="להוסיף דמי ניהול"
      />
    </div>
  );
};

export default observer(ManagementFeesCheckbox);
